/**
 * src/components/layout/Header.jsx
 * Header con título de página y breadcrumb opcional.
 */

export function Header({ title, subtitle, action }) {
  return (
    <div style={{
      padding: 'var(--space-5) var(--space-6) var(--space-4)',
      borderBottom: '1px solid var(--color-border)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: 'var(--color-surface)',
      flexShrink: 0,
    }}>
      <div>
        <h1 style={{
          margin: 0, fontSize: 'var(--text-lg)', fontWeight: 'var(--weight-semibold)',
          color: 'var(--color-text)', letterSpacing: '-0.02em',
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{
            margin: 'var(--space-1) 0 0', fontSize: 'var(--text-sm)',
            color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)',
          }}>
            {subtitle}
          </p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  )
}
